<template>
  <div class="userAccount-manage-container">
    <!-- 上传文件/下载模版 -->
    <el-dialog
      class="dialog_500"
      :visible.sync="upDownDialogVisible"
      center
      :data-page-type="pageType"
      :close-on-click-modal="true"
      custom-class="dialog_normal"
      :append-to-body="true"
      @close="closeUpDownDialog"
    >
      <div class="dialog_content detail_cont">
        <h3 class="margin-bottom20">{{ $t("RiskScan.UploadFiles") }}</h3>
        <div class="flex_center upload-down-up">
          <div>
            <el-upload
              :show-file-list="false"
              action="#"
              :before-upload="beforeUpload"
              :http-request="reportUpload"
              accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            >
              <div class="flex_center" style="flex-direction: column">
                <img
                  v-if="pageType == 'leads'"
                  class="margin-bottom20"
                  src="@/assets/images/lead_up.png"
                />
                <img
                  v-if="isRiskScanning"
                  class="margin-bottom20"
                  src="@/assets/images/upload_icon2.png"
                />
                <img
                  v-else
                  class="margin-bottom20"
                  src="@/assets/images/upload_icon.png"
                />
                <span class="msg_sign font1A2332">
                  {{ $t("RiskScan.PleaseuploadyourfileinCVSformat") }}</span
                >
                <div
                  class="flex_center font999999 font16 margin-top20"
                  style="margin: auto; text-align: center"
                  @click="uploadTemplateDownload"
                >
                  {{ $t("RiskScan.Uploadwithamaximumfilesizeof1M") }}
                </div>
                <!-- <el-button class="line-default-btn" :disabled="!isOperate">
              <i class="iconfont icon-shangchuan size18"></i>上传文件
          
            </el-button> -->
              </div>
            </el-upload>

            <div
              class="flex_center msg_sign margin-top20"
              :class="
                isRiskScanning ? 'upload-down-down-green' : 'upload-down-down'
              "
              style="margin: auto; text-align: center; width: fit-content"
              @click="uploadTemplateDownload"
            >
              {{ $t("RiskScan.Downloadxlsxtemplate") }}
            </div>
          </div>
        </div>
        <div class="dialog-footer flex_center margin-top20 button_content">
          <!-- <el-button
            :class="
              isRiskScanning ? 'btn_risk_cancle' : 'btn_export btn_exporthui'
            "
            @click="closeUpDownDialog"
          >
            <i class="iconfont icon-quxiao"></i>{{ $t("RiskScan.Cancel") }}
          </el-button> -->
          <el-button
            :class="[
              uploadStateRes.percent < 100
                ? 'btn_exporthui btn_export'
                : 'btn_export',
              isRiskScanning ? 'btn_risk_confirm' : '',
            ]"
            @click="closeUpDownDialog"
            :disabled="uploadStateRes.percent < 100"
          >
            <i class="iconfont icon-queren"></i>{{ $t("RiskScan.Confirm") }}
          </el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 上传文件加载 -->
    <el-dialog
      class="dialog_500"
      :visible.sync="uploadDialogVisible"
      center
      :close-on-click-modal="true"
      :data-page-type="pageType"
      custom-class="dialog_normal"
      :append-to-body="true"
      @close="closeUploadDialog"
    >
      <div class="dialog_content detail_cont">
        <h3 class="margin-bottom20">{{ $t("RiskScan.UploadFiles") }}</h3>
        <div class="flex_center upload-down-up">
          <div class="">
            <div class="upload-loading-con">
              <div class="upload-loading-con-echarts">
                <liquidfill
                  :pageType="pageType"
                  ref="uploadRef"
                  :percentage="uploadStateRes.percent"
                ></liquidfill>
              </div>
            </div>
            <div
              class="flex_center msg_sign font1A2332 margin-top20 margin-bottom20"
              v-if="uploadStateRes.percent < 100"
              style="text-align: center"
            >
              {{ $t("RiskScan.Uploading") }}
            </div>
            <div
              class="flex_center msg_sign font1A2332 margin-top20 margin-bottom20"
              v-else
              style="text-align: center"
            ></div>
            <!-- <div
              class="flex_center msg_sign"
              :class="
                isRiskScanning ? 'upload-down-down-green' : 'upload-down-down'
              "
              @click="closeUploadDialog"
            >
              {{ $t("RiskScan.Cancel") }}
            </div> -->
          </div>
        </div>

        <div class="dialog-footer flex_center margin-top20 button_content">
          <!-- <el-button
            :class="
              isRiskScanning ? 'btn_risk_cancle' : 'btn_export btn_exporthui'
            "
            @click="closeUploadDialog"
            style="min-height: 40px !important"
          >
            <i class="iconfont icon-quxiao"></i>{{ $t("RiskScan.Cancel") }}
          </el-button> -->
          <el-button
            :class="[
              uploadStateRes.percent < 100
                ? 'btn_exporthui btn_export'
                : 'btn_export',
              isRiskScanning ? 'btn_risk_confirm' : '',
            ]"
            @click="confirmUploadDialog"
            style="min-height: 40px !important"
            :disabled="uploadStateRes.percent < 100"
          >
            <i class="iconfont icon-queren"></i>{{ $t("RiskScan.Confirm") }}
          </el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 上传文件结束展示结果 -->
    <el-dialog
      class="dialog_500"
      :visible.sync="uploadResDialogVisible"
      center
      :close-on-click-modal="true"
      :data-page-type="pageType"
      custom-class="dialog_normal"
      :append-to-body="true"
      @close="closeUploadResultDialog"
      :class="uploadStateRes.total > 0 ? 'success' : 'fail'"
    >
      <div class="dialog_content detail_cont">
        <h3 class="margin-bottom20">{{ $t("RiskScan.UploadFiles") }}</h3>
        <div class="upload-down-up-last">
          <div class="upload-result-con">
            <img
              v-if="uploadStateRes.total > 0"
              src="@/assets/images/data_upload_success.png"
              alt=""
              class="data-upload-logo"
            />
            <img
              v-else
              src="@/assets/images/data_upload_fail.png"
              alt=""
              class="data-upload-logo"
            />
            <!-- -->
            <div
              class="margin-top20 msg_sign font1A2332"
              v-if="uploadStateRes.successCount > 0"
            >
              <!-- {{ uploadStateRes.total }}
              {{ $t("RiskScan.Xcompanieswereuploadedsucessfuly") }} -->
               {{ $t('RiskScan.Xcompanieswereuploadedsucessfuly', [uploadStateRes.total]) }}
            </div>
          </div>
          <div class="upload-result-dialog" v-if="uploadStateRes.total > 0">
            <div class="">
              <div
                class="flex_center_start"
                style="width: fit-content; margin: auto"
              >
                <img
                  class="upload-result-item-img"
                  src="@/assets/images/data_upload_success_ICON.png"
                  alt=""
                />
                <div class="msg_sign font1A2332">
                  <!-- {{ uploadStateRes.successCount }}
                  {{ $t("RiskScan.Xcompanieswereidentifiedsucessfuly") }} -->
                   {{ $t('RiskScan.Xcompanieswereidentifiedsucessfuly', [uploadStateRes.successCount]) }}
                </div>
              </div>
              <!-- <div
              class="upload-result-item-link msg_sign font1A2332"
              @click="closeUploadResultDialog"
            >
              查看结果
            </div> -->
            </div>
            <div class="">
              <div
                class="flex_center_start margin-top20"
                style="width: fit-content; margin: auto"
              >
                <img
                  class="upload-result-item-img"
                  src="@/assets/images/data_upload_fail_ICON.png"
                  alt=""
                />
                <div class="msg_sign font1A2332">
                  <!-- {{ uploadStateRes.failCount }}
                  {{ $t("RiskScan.Xcompanieswerenotmatched") }} -->
                   {{ $t('RiskScan.Xcompanieswerenotmatched', [uploadStateRes.failCount]) }}
                </div>
              </div>
              <!-- <div
              class="upload-result-item-link msg_sign font1A2332"
              :disabled="uploadStateRes.failCount <= 0"
              @click="downloadUploadFail"
            >
              下载表格
            </div> -->
            </div>
          </div>
          <div
            class="flex_center upload-loading-title msg_sign font1A2332"
            v-else
          >
            <div class="file_failed_msg">
              {{ $t("RiskScan.Uploadingfilefailed") }}
            </div>
          </div>
        </div>
        <div class="dialog-footer flex_center margin-top20 button_content">
          <!-- <el-button
            :class="
              isRiskScanning ? 'btn_risk_cancle' : 'btn_export btn_exporthui'
            "
            style="min-height: 40px !important"
            @click="closeUploadResultDialog"
          >
            <i class="iconfont icon-quxiao"></i>{{ $t("RiskScan.Cancel") }}
          </el-button> -->
          <el-button
            v-if="uploadStateRes.total > 0"
            :class="isRiskScanning ? 'btn_risk_confirm' : 'btn_export'"
            style="min-height: 40px !important"
            @click="confirmUploadResultDialog"
          >
            <i class="iconfont icon-queren"></i>{{ $t("RiskScan.Confirm") }}
          </el-button>
          <el-button
            v-else
            :class="isRiskScanning ? 'btn_risk_confirm' : 'btn_export'"
            style="min-height: 40px !important"
            @click="confirmUploadResultDialog"
          >
            <i class="iconfont icon-queren"></i>{{ $t("RiskScan.Tryagain") }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 批量入组/加入他组 -->

    <!-- 加入监踪 -->
  </div>
</template>

<script>
import liquidfill from "./liquidfill.vue";
import { userCompanyActionupload, getUploadResult } from "@/api/companyApi.js";

// import {

//   upload,
//   getUploadStatus,

// } from "@/api/personalCenter.js";

export default {
  props: {
    UpdateFileDialog: {
      type: Boolean,
    },
    isUploaded: {
      type: Boolean,
    },
    pageType: {
      type: String,
    },
    isRiskScanning: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    liquidfill,
  },

  computed: {
    upDownDialogVisible: {
      get() {
        return this.UpdateFileDialog;
      },
      set() {},
    },
  },
  watch: {
    UpdateFileDialog: {
      handler(newVal, oldVal) {
        // 这里可以进行一些逻辑处理或者触发其他操作
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
  },
  data() {
    return {
      from: {
        isNewGrouping: false,
        checkList: [""],
        newGroupName: "",
      },
      groups: [],

      collectDialogVisible: false,

      collectType: "add",
      analysisCheckList: [],
      // 批量更新-上传文件
      newfileFormData: {},
      timer: "",
      uploadStateRes: {
        percentage: 0,
        percent: 0,
        total: 0,
        successCount: 0,
        failCount: 0,
        failList: [],
        failMatchList: [],
        successMatchList: [],
      },
      dialogFailedVisible: false,

      failedType: "",
      uploadDialogVisible: false,
      uploadResDialogVisible: false,
      editGroupDialogVisible: false,
      collectGroupIndex: -1,

      isShowBack: false,
      matchDialogVisible: false,
      nomatchDialogVisible: false,

      uploadId: null,

      upStaus: "",
      // 加入监踪
    };
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    beforeUpload(file) {
      const Xls = file.name.split(".");
      if (Xls[1] === "xls" || Xls[1] === "xlsx") {
        file.isUpload = "1";

        const files = new FormData();
        files.append("file", file);
        files.append("isUpload", 1); //  2. 上传之前，拿到file对象，并将它添加到刚刚定义的FormData对象中。
        this.newfileFormData = files;
      } else {
        this.$message.error($t("RiskScan.Theuploadedonlyxlsx"));
        return false;
      }
    },
    // 限制文件上传大小
    //         handleBeforeUpload(file){
    //   const isSizeValid = file.size / 1024 / 1024 < 5; // 5MB
    //   if (!isSizeValid) {
    //     this.$message.error("文件大小不能超过5MB");
    //   }
    //   return isSizeValid;
    // }
    // },
    // 上传文件
    async reportUpload(params) {
      let file = params.file;
      let form = new FormData();
      form.append("file", file);
      try {
        this.uploadStateRes = {
          percentage: 0,
          total: 0,
          successCount: 0,
          percent: 0,
          failCount: 0,
          failList: [],
          failMatchList: [],
          successMatchList: [],
        };

        let res = await userCompanyActionupload(this.newfileFormData);
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.upDownDialogVisible = false;
          this.uploadDialogVisible = true;
          //   setTimeout(() => {
          //     this.uploadDialogVisible = true;
          //   }, 1000);
          await this.timerGetFileStatu(res.data.markToken);
        } else {
          if (res.code == "-2") {
            this.uploadResDialogVisible = true;
          } else {
            this.$message.error(res.msg);
          }
        }
      } catch (err) {
        if (err.code == "-2") {
          this.uploadResDialogVisible = true;
        } else {
          this.$message.error(err.msg);
        }
      }
    },
    // 定时查询文件状态
    async timerGetFileStatu(filesId) {
      this.timer = setInterval(async () => {
        try {
          let res = await getUploadResult({
            markToken: filesId,
          });
          if (res.code && res.data) {
            this.uploadStateRes = res.data;
            this.uploadStateRes.successCount =
              res.data?.successMatchList?.length;
            this.uploadStateRes.failCount = res.data?.failMatchList?.length;
            this.uploadStateRes.total = res.data?.total;
            this.uploadStateRes.percent = res.data.percent;
            if (res.data.percent == 100) {
              clearInterval(this.timer);
            }
          }
        } catch (err) {
          // this.$message.error("系统找不到指定的文件");
          clearInterval(this.timer);
          this.uploadDialogVisible = false;
        }
      }, 5000);
      setTimeout(() => {
        clearInterval(this.timer);
      }, 180000);
      // 通过$once来监听定时器，在beforeDestroy钩子可以被清除。
      this.$once("hook:beforeDestroy", () => {
        clearInterval(this.timer);
      });
    },
    closeUploadResultDialog() {
      this.uploadResDialogVisible = false;
    },
    confirmUploadResultDialog() {
      this.$emit("uploadSuccess");
      if (this.isUploaded) {
        this.$parent.getgetUserActionLogPage();
      } else {
        this.$router
          .push({
            path: "/account/companiesViewed",
            query: {
              type: 4,
            },
          })
          .then(() => {
            this.$router.go(0);
          });
      }
      this.uploadResDialogVisible = false;
    },
    closeUploadDialog() {
      clearInterval(this.timer);
      this.uploadDialogVisible = false;
      this.uploadStateRes.percentage = 0;
    },
    closeUpDownDialog() {
      this.$emit("closeUpDownDialog", false);
    },
    // 上传数量确认
    confirmUploadDialog() {
      this.uploadDialogVisible = false;
      this.uploadResDialogVisible = true;
      this.uploadStateRes.percentage = 0;
    },
    uploadTemplateDownload() {
      var a = document.createElement("a");
      a.href = "/batchUpload_template.xlsx";
      a.download = "Download template.xlsx";
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      a.remove();
    },

    // 上传-下载表格
    downloadUploadFail() {
      let list = [];
      this.uploadStateRes.failList.map((item) => {
        list.push({
          entname: item,
        });
      });
      let exportColumns = [
        {
          header: "公司名称",
          key: "entname",
          formatFun: formatFunStr,
          width: 30,
        },
      ];
      let exportName = "我的上传-未匹配数据";
    },
  },
};
</script>

<style lang="css" scoped>
.userAccount-manage-box {
  padding: 0 30px 20px 30px;
}

.upload-loading-con {
  display: flex;
  justify-content: center;
  align-items: center;
  /* width: 170px;
  height: 170px; */
  margin-bottom: 20px;
  border-radius: 50%;
  background: #f5f7fa;
}

.upload-loading-con-echarts {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
}

.upload-loading-title {
  width: 100%;
  height: 76px;
  font-size: 16px;
  background: #f5f7fa;
  border-radius: 10px;
}

.upload-result-con {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}

.upload-result-title {
  width: 100%;
  height: 26px;
  line-height: 26px;
  margin-top: 10px;
  font-family: "HarmonyOS_Sans_SC_Bold";
  font-size: 16px;
  color: #1a2332;
  text-align: center;
}

.upload-result-dialog {
  width: 100%;
  padding: 20px;
  background: #ffffff;
  border-radius: 10px;
}

.upload-result-dialog .upload-result-item:not(:last-child) {
  margin-bottom: 30px;
}

.upload-result-item-img {
  width: 26px;
  height: 26px;
  margin-right: 14px;
}

.upload-result-item-link {
  font-size: 16px;
  color: #016ff6;
  text-decoration: underline;
  cursor: pointer;
}

.display_switch {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 96px;
  height: 36px;
  margin-left: 20px;
  padding: 8px 15px 8px 0px;
  background: #e7ebf2;
  border-radius: 18px;
  cursor: pointer;
}

.display_switch .active {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 46px;
  height: 32px;
  background: #ffffff;
  box-shadow: 0px 2px 2px 0px #d3d8de;
  border-radius: 16px;
}

.display_switch .active i {
  font-size: 22px;
  color: #016ff6;
}

.display_switch i {
  font-size: 20px;
  color: #999999;
}

.company-operate-popper-con {
  display: flex;
  flex-direction: column;
}

.company-operate-popper-con >>> .el-button + .el-button,
.el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 0;
  margin-top: 10px;
}

.operate-con {
  display: flex;
  align-items: center;
  height: 36px;
}

.operate-btn .icon-gongju {
  font-size: 20px;
}

.account-content-panel {
  padding-top: 0;
}

.userAccount-manage-title {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  height: 56px;
  padding-right: 20px;
}

.title-txt {
  display: flex;
  align-items: flex-end;
  line-height: 20px;
  padding-bottom: 6px;
}

.back-btn {
  width: 140px;
  margin-left: 20px;
}

.back-btn .icon-fanhui {
  margin-top: 4px;
  font-size: 20px;
}

.tab-operate {
  margin-top: -6px;
}

.collect-btn {
  width: 120px;
}

.data-upload-dialog >>> .el-dialog__body {
  padding: 40px 0 0 0;
}

.data-upload-dialog >>> .el-dialog__footer,
.data-collect-dialog >>> .el-dialog__footer {
  padding: 30px 0 0 0;
}

.data-upload-dialog.success >>> .el-dialog__footer {
  padding: 20px 0 0 0;
}

.data-upload-dialog.fail >>> .el-dialog__footer {
  padding: 40px 0 0 0;
}

.data-collect-dialog >>> .el-dialog {
  min-height: 200px;
}

.data-collect-dialog >>> .el-form-item {
  margin-bottom: 0;
}

.data-group-dialog >>> .el-form-item:not(:last-child) {
  margin-bottom: 20px;
}

.dialog_modal >>> .el-form-item__content {
  line-height: 36px;
}

.dialog_modal >>> .el-form-item__label {
  display: flex;
  align-items: center;
  height: 36px;
  line-height: 18px;
  padding-right: 10px;
  font-family: "HarmonyOS_Sans_SC";
  font-size: 14px;
  color: #1a2332;
  text-align: left;
}

.dialog_modal >>> .el-input__inner {
  height: 36px;
  line-height: 36px;
  padding: 0 12px;
  font-family: "HarmonyOS_Sans_SC";
  font-size: 14px;
  color: #1a2332;
  border-radius: 10px;
  border: 1px solid #cccccc;
}

.dialog_modal >>> .el-pagination__editor .el-input__inner {
  border-radius: 4px;
}

.data-match-dialog >>> .el-dialog__body {
  padding: 10px 0 0 0;
}

.dialog_content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.data-upload-logo {
  width: 106px;
  height: 106px;
}

.childtable >>> .mydata-table-con {
  padding: 0;
}

.childtable >>> .pagination-container {
  padding: 0 !important;
}

.mydata-table-con >>> .el-table__expanded-cell .pagination-container {
  width: auto;
}

.childtable >>> .table-operate-icon {
  right: 0;
}

.mydata-table-con >>> .selection-td .cell {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.mydata-table-con >>> .expand-td {
  padding-left: 8px;
}

.mydata-table-con >>> th.selection-td {
  border-left: none !important;
}

.mydata-table-con >>> th.selection-td .cell,
.mydata-table-con >>> .el-table__row .selection-td.el-table__cell .cell {
  line-height: 1;
}

.mydata-table-con >>> .el-table--border {
  border-left: none !important;
}

.mydata-table-con >>> .el-table__row .selection-td {
  border-left: 1px solid #dddddd;
}

.mydata-table-con >>> tr td:last-child .cell > span:not(:last-child),
.mydata-table-con >>> tr.expanded .cell > span:not(:last-child) {
  margin-right: 27px;
}

.size22 {
  font-size: 22px !important;
}

.data-match-dialog >>> .el-dialog {
  padding: 20px 0px 20px 20px;
}

.data-match-dialog .dialog_content {
  padding-right: 20px;
  max-height: none;
}

.dialog-search-form-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: auto;
  padding: 14px 10px;
  margin-bottom: 6px;
  background: #f5f7fa;
  border-radius: 4px 4px 0px 0px;
  white-space: nowrap;
}

.dialog-search-form-box >>> .el-form-item {
  margin-bottom: 0 !important;
  margin-right: 0 !important;
}

.dialog-search-form-box >>> .el-input__inner {
  padding-right: 30px !important;
}

.dialog-search-form-box >>> .dialog-search-form-name {
  width: 280px !important;
}

.dialog-search-form-box >>> .el-input__suffix-inner {
  display: flex;
  width: 16px;
  height: 36px;
}

.dialog-search-form-box >>> .el-input__icon {
  line-height: 36px;
  font-size: 16px !important;
  color: #1a2332 !important;
}

.dialog-search-form-btn >>> .el-form-item__content {
  display: flex;
  align-items: center;
}

.dialog-search-form-search,
.dialog-search-form-reset {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid #cccccc;
}

.dialog-search-form-search {
  margin-left: 8px;
  background: #016ff6;
}

.dialog-search-form-search i {
  font-size: 16px;
  color: #ffffff;
}

.dialog-search-form-reset {
  background: #ffffff;
}

.dialog-search-form-reset i {
  font-size: 22px;
  color: #1a2332;
}

.dialog-search-form-reset:hover {
  background: #016ff6;
}

.dialog-search-form-reset:hover i {
  color: #ffffff;
}

.display-from-div {
  height: 452px;
}

.edit-collect-dialog .display-from-div {
  height: auto;
  max-height: 500px;
}

.data-match-dialog >>> .radio-td .cell {
  display: flex;
  justify-content: center;
  padding-left: 0 !important;
}

.nomatch-con {
  width: 100%;
  padding: 0 20px;
  background: #f5f7fa;
  border-radius: 4px 4px 0px 0px;
}

.nomatch-con-title {
  line-height: 24px;
  padding: 40px 0;
  font-size: 14px;
  color: #999999;
  text-align: center;
  border-bottom: 1px solid #dddddd;
}

.nomatch-con-form {
  height: 419px;
  padding-top: 20px;
}

.nomatch-con-form-title {
  line-height: 26px;
  margin-bottom: 20px;
  font-family: "HarmonyOS_Sans_SC_Bold";
  font-size: 14px;
  color: #1a2332;
}

.nomatch-con-form-con {
  display: flex;
  justify-content: space-between;
}

.nomatch-con-form-con >>> .dialog-result-form-name {
  width: 330px !important;
}

.dialog_modal >>> .el-input__count {
  bottom: 6px;
  right: 6px;
  height: 12px;
  line-height: 12px;
  color: #999999;
}

.upload-down-up {
  height: 330px;
  width: 100%;
  padding: 40px 15px 30px 15px;
  background: #f5f7fa;
  border-radius: 10px;

  cursor: pointer;
  font-size: 20px;
  color: #1a2332;
}

.upload-down-down {
  width: 220px;
  height: 40px;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #1290c9;
  padding: 0 20px;
  color: #1290c9;
}
.upload-down-down-green {
  width: 220px;
  height: 40px;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #334b35;
  padding: 0 20px;
  color: #334b35;
}
.btn_risk_cancle {
  background: #cadecc !important;
  color: #334b35 !important;
}
.btn_risk_confirm {
  background: #334b35 !important;
  color: #ffffff !important;
}

.upload-down-up-last {
  height: 330px;
  width: 100%;
  padding: 40px 15px 30px 15px;
  text-align: center;
  background: #f5f5f5;
  border-radius: 10px;
  padding: 20px;
}
::v-deep .dialog_normal {
  width: 800px;
  height: 522px;
  border-radius: 30px;
}
.upload-down-up img {
  height: 100px;
}
.btn_cancel,
.el-button,
.btn_export {
  min-width: 210px !important;
  height: 60px;
  margin-left: 0px !important;
}
.button_content {
  gap: 40px;
}
.msg_sign {
  font-size: 20px;
  min-height: 20px;
}
.file_failed_msg {
  margin-bottom: 40px;
}
@media (max-width: 1920px) {
  ::v-deep .dialog_normal {
    width: 600px;
    height: 390px;
    border-radius: 22px;
  }
  .upload-down-up {
    height: 250px;

    padding: 30px 12px 22px 12px;
    border-radius: 8px;
    font-size: 16px;
  }
  .upload-down-up img {
    height: 75px;
  }
  .upload-down-up-last {
    height: 250px;
    padding: 30px 12px 22px 12px;
    border-radius: 8px;
    font-size: 16px;
  }

  .upload-result-dialog {
    padding: 15px;
    border-radius: 8px;
  }
  .data-upload-logo {
    height: 80px;
    width: 80px;
  }

  .upload-down-down {
    width: 165px;
    height: 30px;
    border-radius: 8px;
    padding: 0 15px;
  }
  .btn_cancel,
  .el-button,
  .btn_export {
    min-width: 158px !important;
    height: 46px;
  }
  .button_content {
    gap: 30px;
  }
  .msg_sign {
    font-size: 16px;
    min-height: 16px;
  }
  .upload-loading-con-echarts {
    width: 112px;
    height: 112px;
  }
  .file_failed_msg {
    margin-bottom: 30px;
  }
}

@media (max-width: 1439px) {
  ::v-deep .dialog_normal {
    width: 540px;
    height: 350px;
    border-radius: 22px;
  }
  .upload-down-up {
    height: 220px;
    padding: 20px 10px 20px 10px;
    border-radius: 7px;
    font-size: 14px;
  }
  .upload-down-up img {
    height: 67px;
  }
  .upload-down-up-last {
    height: 220px;
    padding: 20px 10px 20px 10px;
    border-radius: 7px;
    font-size: 14px;
  }
  .upload-result-dialog {
    padding: 13px;
    border-radius: 7px;
  }
  .data-upload-logo {
    height: 70px;
    width: 70px;
  }
  .upload-down-down {
    width: 150px;
    height: 26px;
    border-radius: 7px;
    padding: 0 13px;
  }
  .btn_cancel,
  .el-button,
  .btn_export {
    min-width: 140px;
    height: 40px;
  }
  .button_content {
    gap: 26px;
  }
  .msg_sign {
    font-size: 14px;
    min-height: 14px;
  }
  .upload-loading-con-echarts {
    width: 100px;
    height: 100px;
  }
  .file_failed_msg {
    margin-bottom: 26px;
  }

  .upload-result-dialog {
    padding: 13px;
    border-radius: 7px;
  }
  .data-upload-logo {
    height: 70px;
    width: 70px;
  }
  .upload-down-down {
    width: 150px;
    height: 26px;
    border-radius: 7px;
    padding: 0 13px;
  }
  .btn_cancel,
  .el-button,
  .btn_export {
    min-width: 140px !important;
    height: 40px;
  }
  .button_content {
    gap: 26px;
  }
  .msg_sign {
    font-size: 14px;
    min-height: 14px;
  }
  .upload-loading-con-echarts {
    width: 100px;
    height: 100px;
  }
  .file_failed_msg {
    margin-bottom: 26px;
  }
}
</style>
